<template>
  <div class="mains">
    <div class="ret_box">
      <!--   -->
      <div class="ret" @click="ret">
        <img class="ret_img" src="@/img/regular-back.png" alt="" />
      </div>

      <div class="nav_text">{{ $t("name.Avatar") }}</div>
    </div>
    <div class="name_box">
      <img
        class="name_img"
        @click="select(index)"
        :class="index == i ? 'active' : ''"
        v-for="(item, index) in data"
        :src="item"
        alt=""
        :key="index"
      />
    </div>
    <div @click="confirm" class="button">{{ $t("name.Confirm") }}</div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      i: -1,
      data: [
        "/h5tga4bip/imgs/head1.png",
        "/h5tga4bip/imgs/head2.png",
        "/h5tga4bip/imgs/head3.png",
        "/h5tga4bip/imgs/head4.png",
        "/h5tga4bip/imgs/head5.png",
        "/h5tga4bip/imgs/head6.png",
        "/h5tga4bip/imgs/head7.png",
        "/h5tga4bip/imgs/head8.png"
      ]
    };
  },
  computed: {
    ...mapState("user", ["userInfo"])
  },
  methods: {
    select(index) {
      console.log(index);
      this.i = index;
      // this.userInfo.header = '/h5tga4bip/imgs/head1.png'

      console.log(this.userInfo, "444");
    },
    confirm() {
      var data = {};
      data.show = false;
      if (this.i != -1) {
        data.url = this.data[this.i];
      }
      this.$emit("ret", data);
    },
    ret() {
      var data = {};
      data.show = false;

      this.$emit("ret", data);
    }
  }
};
</script>

<style scoped="scoped">
.mains {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
}

.ret_box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.5rem;
  width: 100%;
  position: relative;
}
.nav_text {
  font-size: 0.4rem;
  color: #222222;
  font-weight: bold;
}
.ret {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  box-sizing: border-box;
  width: 1rem;
  height: 1.5rem;
  padding: 0 0 0 0.51rem;
  display: flex;
  align-items: center;
}
.ret_img {
  width: 0.33rem;
  height: 0.54rem;
}
.name_box {
  margin: 0 auto 0;
  width: 10rem;
  height: 5.7rem;
  border-radius: 0.2rem;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0.62rem 0.42rem;
}
.name_img {
  width: 1.96rem;
  height: 1.96rem;
  border: 0.06rem solid #ffffff;
  border-radius: 0.2rem;
}
.active {
  border: 0.06rem solid #03a9f5;
}

.button {
  margin: 0.5rem auto 0;
  width: 9.01rem;
  height: 1.21rem;
  background-color: #03a9f5;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 0.48rem;
}
</style>



// WEBPACK FOOTER //
// src/components/name.vue